import {createGlobalStyle} from "styled-components";

const ProjectStyle = createGlobalStyle`
    .project .projectHead{
        font-size: 35px;
        color: #ff9f46;
    }
    .project .projectWrap .ProjectName{
        color: #FF9F46;
        padding-top: 20px;
        padding-bottom: 3px;
        font-weight: 100;
        font-size: 14px;
        text-transform: uppercase;
        position: relative;
    }
    .project .projectWrap .ProjectName::before{
        content: '';
        width: 70px;
        height: 3px;
        position: absolute;
        top: 9px;
        background: #000;
        border-radius: 40px;
    }
    .project .projectWrap .ProjectDesc{
        font-size: 20px;
        font-weight: 500;
        color: #000
    }
`;

export default ProjectStyle;
